import Cookies from "universal-cookie";
import axios from "axios";
import Config from "../../config/index";
import {
  CREATE_USER_FAILURE,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  EDIT_USER_FAILURE,
  EDIT_USER_REQUEST,
  EDIT_USER_SUCCESS,
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
} from "./usersTypes";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();
const userData = cookies.get("loginDetailsForSupport");

const getUserRequest = () => {
  return {
    type: GET_USER_REQUEST,
  };
};

const getUserSuccess = (payload) => {
  return {
    type: GET_USER_SUCCESS,
    payload: payload,
  };
};

const getUserFaliure = (error) => {
  return {
    type: GET_USER_FAILURE,
    payload: error,
  };
};

const getUser = (clientId, token) => {
  return (dispatch) => {
    dispatch(getUserRequest());
    let url = `${baseUrl}/users_management/users/user_by_clientId?client_id=${clientId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getUserSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getUserFaliure(err.message));
      });
  };
};

const createUserRequest = () => {
  return {
    type: CREATE_USER_REQUEST,
  };
};

const createUserSuccess = (payload) => {
  return {
    type: CREATE_USER_SUCCESS,
    payload: payload,
  };
};

const createUserFaliure = (error) => {
  return {
    type: CREATE_USER_FAILURE,
    payload: error,
  };
};

const createUser = (payload, token) => {
  return (dispatch) => {
    dispatch(createUserRequest());
    let url = `${baseUrl}/users_management/users/create_user`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(createUserSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createUserFaliure(err.response));
        return { status: false, response: err.response.data };
      });
  };
};

const editUserRequest = () => {
  return {
    type: EDIT_USER_REQUEST,
  };
};

const editUserSuccess = (payload) => {
  return {
    type: EDIT_USER_SUCCESS,
    payload: payload,
  };
};

const editUserFaliure = (error) => {
  return {
    type: EDIT_USER_FAILURE,
    payload: error,
  };
};

const editUser = (payload, token) => {
  return (dispatch) => {
    dispatch(editUserRequest());
    let url = `${baseUrl}/users_management/users/update`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .put(url, payload, config)
      .then((response) => {
        dispatch(editUserSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editUserFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const deleteUserRequest = () => {
  return {
    type: DELETE_USER_REQUEST,
  };
};

const deleteUserSuccess = (payload) => {
  return {
    type: DELETE_USER_SUCCESS,
    payload: payload,
  };
};

const deleteUserFaliure = (error) => {
  return {
    type: DELETE_USER_FAILURE,
    payload: error,
  };
};

const deleteUser = (userId, token) => {
  return (dispatch) => {
    dispatch(deleteUserRequest());
    let url = `${baseUrl}/users_management/users/delete?user_id=${userId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .put(url, {}, config)
      .then((response) => {
        dispatch(deleteUserSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteUserFaliure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export { getUser, createUser, editUser, deleteUser };
